import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
//   const token = sessionStorage.getItem('authToken');
   const token = localStorage.getItem('token'); // Or use localStorage if that's your auth method
  const location = useLocation();

  return token
    ? children
    : <Navigate to="/" replace state={{ from: location }} />;
};

export default ProtectedRoute;
